/* eslint-disable import/no-anonymous-default-export */
export default [
  {
    "id": "prod_Q0vddoQSpGVIt7",
    "name": "XAPP AI Max for Jobber",
    "active": true,
    "metadata": {
      "chat": "true",
      "form": "true",
      "gbm": "true",
      "live-chat": "true",
      "partner": "jobber",
      "search": "true"
    },
    "description": "XAPP AI Assistant + XAPP AI Scheduler for Jobber"
  },
  {
    "id": "prod_Q0vcEqeAgJPf1P",
    "name": "XAPP AI Complete for Jobber",
    "active": true,
    "metadata": {
      "chat": "true",
      "form": "false",
      "gbm": "true",
      "live-chat": "true",
      "partner": "jobber",
      "search": "true"
    },
    "description": "XAPP AI's Full Suite of AI Powered Assistant Offerings for Jobber"
  },
  {
    "id": "prod_Q0vaeHeo79OAMF",
    "name": "XAPP AI Scheduler for Jobber",
    "active": true,
    "metadata": {
      "chat": "true",
      "form": "true",
      "live-chat": "true",
      "partner": "jobber"
    },
    "description": "AI Powered Scheduler to increase self-service booking events with Jobber Integration"
  },
  {
    "id": "prod_Pz5ozkG9sQs5cE",
    "name": "XAPP AI Starter",
    "active": true,
    "metadata": {},
    "description": "Entry Level AI solution to help you agents deflect calls"
  },
  {
    "id": "prod_Pz5mftE4HuDL9w",
    "name": "XAPP AI Complete",
    "active": true,
    "metadata": {
      "chat": "true",
      "gbm": "true",
      "live-chat": "true",
      "search": "true"
    },
    "description": "XAPP AI's Full Suite of AI Powered Assistant Offerings"
  },
  {
    "id": "prod_Pz5ILeuI4etQgt",
    "name": "XAPP AI Max",
    "active": true,
    "metadata": {
      "chat": "true",
      "form": "true",
      "gbm": "true",
      "live-chat": "true",
      "search": "true"
    },
    "description": "XAPP AI Assistant + XAPP AI Scheduler"
  },
  {
    "id": "prod_PyhhowcAKFU6hU",
    "name": "XAPP AI Scheduler",
    "active": true,
    "metadata": {
      "chat": "true",
      "form": "true",
      "legacy": "false",
      "live-chat": "true"
    },
    "description": "AI Powered Scheduler to increase self-service booking events"
  },
  {
    "id": "prod_POZTzT6ODXkvpR",
    "name": "XAPP AI Max for Surefire Local",
    "active": true,
    "metadata": {
      "SKU": "SFL Max",
      "partner": "sfl"
    },
    "description": "XAPP Chat and Intelligent Search and GBM for Surefire Local"
  },
  {
    "id": "prod_POTEY2KVOVkAVP",
    "name": "XAPP AI Complete for Surefire Local",
    "active": true,
    "metadata": {
      "SKU": "SFL Complete",
      "partner": "sfl"
    },
    "description": "XAPP Chat and Intelligent Search for Surefire Local"
  },
  {
    "id": "prod_POSa3djoK3AHnW",
    "name": "XAPP AI Leads for Surefire Local",
    "active": true,
    "metadata": {
      "SKU": "SFL Leads",
      "partner": "sfl"
    },
    "description": "XAPP Chat for Surefire Local"
  },
  {
    "id": "prod_OioLLzR42jsj4X",
    "name": "Jobber Starter",
    "active": true,
    "metadata": {
      "SKU": "JOB START",
      "partner": "jobber"
    },
    "description": "Free web chat for deflection only"
  },
  {
    "id": "prod_OYOxZy5zeau3qS",
    "name": "XAPP AI Max (L)",
    "active": true,
    "metadata": {
      "chat": "true",
      "gbm": "true",
      "legacy": "true",
      "live-chat": "true",
      "search": "true",
      "sku": "X Max"
    },
    "description": "AI Powered Chat, Intelligent Search, GBM - Legacy"
  },
  {
    "id": "prod_OTWFLK7Zg3YOW5",
    "name": "Jobber Max (L)",
    "active": true,
    "metadata": {
      "chat": "true",
      "gbm": "true",
      "legacy": "true",
      "live-chat": "true",
      "partner": "jobber",
      "search": "true",
      "sku": "JOB MAX"
    },
    "description": "AI Powered Chat, Intelligent Search, GBM, and Jobber Integration"
  },
  {
    "id": "prod_OTWELanEF9Frvb",
    "name": "Jobber Complete (L)",
    "active": true,
    "metadata": {
      "chat": "true",
      "gbm": "false",
      "legacy": "true",
      "live-chat": "true",
      "partner": "jobber",
      "search": "true",
      "sku": "JOB COMPLETE"
    },
    "description": "AI Powered Chat , Intelligent Search and Jobber Integration"
  },
  {
    "id": "prod_OTWBkJ5zC7gwPE",
    "name": "Jobber Leads",
    "active": true,
    "metadata": {
      "chat": "true",
      "gbm": "false",
      "live-chat": "true",
      "partner": "jobber",
      "search": "false",
      "sku": "JOB LEADS"
    },
    "description": "AI Powered Chat and Jobber Integration"
  },
  {
    "id": "prod_OTVhAvqgcNT8kl",
    "name": "XAPP AI Complete (L)",
    "active": true,
    "metadata": {
      "chat": "true",
      "gbm": "false",
      "legacy": "true",
      "live-chat": "true",
      "search": "true",
      "sku": "X ESS"
    },
    "description": "AI Powered Chat and Intelligent Search - Legacy"
  },
  {
    "id": "prod_OTVaCIwOCO7KrD",
    "name": "XAPP AI Leads",
    "active": true,
    "metadata": {
      "chat": "true",
      "gbm": "false",
      "live-chat": "true",
      "search": "false",
      "sku": "X LEAD"
    },
    "description": "AI Powered Chat with Lead Capture & Live Agent Take-Over"
  },
  {
    "id": "prod_OHSayEKfN87zZ8",
    "name": "LACRM Max Plan",
    "active": true,
    "metadata": {
      "chat": "true",
      "gbm": "true",
      "live-chat": "true",
      "partner": "lacrm",
      "search": "true",
      "sku": "LACRM MAX"
    },
    "description": "AI powered chat, intelligent search, and GBM solutions integrated with the LACRM platform.  Includes enhanced reporting"
  },
  {
    "id": "prod_OHSXTXKLOTo3FO",
    "name": "LACRM Complete Plan",
    "active": true,
    "metadata": {
      "chat": "true",
      "gbm": "false",
      "partner": "lacrm",
      "search": "true",
      "sku": "LACRM ESS"
    },
    "description": "AI powered chat and intelligent search solutions integrated with LACRM platform.  Includes enhanced reporting "
  },
  {
    "id": "prod_OHSVoiwdfyntlj",
    "name": "LACRM Leads Plan",
    "active": true,
    "metadata": {
      "chat": "true",
      "gbm": "false",
      "partner": "lacrm",
      "search": "false",
      "sku": "LACRM START"
    },
    "description": "Intelligent chat solution integrated with LACRM platform"
  },
  {
    "id": "prod_OA2AUH1GkVSh7r",
    "name": "ServiceTitan Integration - HS",
    "active": true,
    "metadata": {},
    "description": "ServiceTitan Integration"
  },
  {
    "id": "prod_OA29T2WJBN83yd",
    "name": "Additional GBM - HS",
    "active": true,
    "metadata": {},
    "description": "GBM as an add on channel for home services"
  },
  {
    "id": "prod_OA27nOGdsIeyBZ",
    "name": "Additional  Search - HS",
    "active": true,
    "metadata": {},
    "description": "Site search as an add on channel for home services"
  },
  {
    "id": "prod_OA262xa8x9IZyK",
    "name": "AI Powered Chat - HS",
    "active": true,
    "metadata": {},
    "description": "AI powered web chat for home services"
  }
]
